import Projects from '../components/projects';


export default Projects;